import { ButtonRadioGroupField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import { changeAgentCallsForbidden, changeComissionType } from '../../../state/advanced/comission';
import { InlineParam, Row } from '../markup';

export interface ICommissionProps {
  commissionType: number | undefined;
  onComissionTypeChanged(value: number): void;

  agentsCallsForbidden: boolean;
  onAgentCallsForbiddenChanged(value: boolean): void;
}

export const comission: React.StatelessComponent<ICommissionProps> = props => (
  <Row title="Комиссия">
    <InlineParam>
      <ButtonRadioGroupField
        uncheckable={true}
        value={String(props.commissionType)}
        onValueChange={value => props.onComissionTypeChanged(value !== undefined ? Number(value) : value)}
        values={[
          { value: '1', label: 'Эксклюзивная' },
          { value: '0', label: 'Без комиссии' },
        ]}
      />
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onAgentCallsForbiddenChanged(!value)}
        value={props.agentsCallsForbidden}
      >
        Без «Агентам не звонить»
      </ButtonCheckbox>
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    commissionType: state.filters.jsonQuery.commission_type && state.filters.jsonQuery.commission_type.value,
    agentsCallsForbidden: (state.filters.jsonQuery.cl && !state.filters.jsonQuery.cl.value) || false,
  }),
  (dispatch: Dispatch) => ({
    onComissionTypeChanged: (value: number) => {
      dispatch(changeComissionType(value));
    },
    onAgentCallsForbiddenChanged: (value: boolean) => {
      dispatch(changeAgentCallsForbidden(value));
    },
  }),
)(comission);
